module.exports = __webpack_public_path__ + "img/Unidad13-2.2405b5ec.png";